import { useTranslations } from '@/contexts/translation/useTranslations';
import useGetAuthentication from '@/domains/authentication/useGetAuthentication.ts';
import useLoginForm, {
  LoginFieldType,
} from '@/pages/authentication/Login/LoginForm/useLoginForm.ts';
import useAuthNavigator from '@/pages/authentication/navigation/useAuthNavigator.ts';
import ThemeButton from '@/theme/Components/ThemeButton/ThemeButton.tsx';
import useThemeContext from '@/theme/context/useThemeContext.ts';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Flex, Form, Input, Typography } from 'antd';

interface LoginFormProps {
  handleForgotPassword: () => void;
}

const LoginForm = ({ handleForgotPassword }: LoginFormProps) => {
  const { onFinish } = useLoginForm();
  const { userType } = useAuthNavigator();
  const { data } = useGetAuthentication();
  const {
    light: { colors },
  } = useThemeContext();
  const { t } = useTranslations({ ns: 'auth' });

  return (
    <Form
      autoComplete="off"
      initialValues={{ sec_token: data?.pageData?.attributes?.sec_token || '' }}
      name="login-form"
      onFinish={onFinish}
      style={{ width: '100%' }}
    >
      <Form.Item<LoginFieldType>
        name="email"
        rules={[
          {
            required: true,
            message: t(`login.${userType}.required_email_message`),
          },
        ]}
      >
        <Input
          placeholder={t(`login.${userType}.email_placeholder`)}
          prefix={<UserOutlined />}
          variant="filled"
        />
      </Form.Item>

      <Form.Item<LoginFieldType>
        name="password"
        rules={[
          {
            required: true,
            message: t(`login.${userType}.required_password_message`),
          },
        ]}
        style={{ marginBottom: 0 }}
      >
        <Input.Password
          placeholder={t(`login.${userType}.password_placeholder`)}
          prefix={<LockOutlined />}
          variant="filled"
        />
      </Form.Item>

      <Form.Item<LoginFieldType> hidden={true} name="sec_token">
        <Input.Password />
      </Form.Item>

      <Flex justify={'end'} style={{ padding: '8px 0 24px' }}>
        <Typography.Link
          onClick={handleForgotPassword}
          style={{
            color: colors.primaryText,
            fontStyle: 'italic',
            textDecoration: 'underline',
          }}
        >
          {t(`login.${userType}.actions.forgot_password`)}
        </Typography.Link>
      </Flex>

      <ThemeButton block htmlType="submit" style={{ flex: 1 }} type="primary">
        {t(`login.${userType}.actions.login`)}
      </ThemeButton>
    </Form>
  );
};

export default LoginForm;
